<!-- 已迁移 -->
<template>
    <div class="layout-content">
        <div class="el-router-view">
            <slot name="routerView"></slot>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {}
};
</script>

<style lang="less" scoped>
.layout-content {
    width: 100%;

    .layout-menus {
        width: 208px;
        height: 100%;
        background: #292d3e;
    }

    .el-router-view {
        max-width: 1920px;
        // padding: 0 24px 24px;
        margin: 0 auto;

        .el-router-content {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
